import s from "./ProgressBar.module.scss";

type Props = {
  /** Leave out while the amount is not known yet: the bar is indeterminate (no aria-valuenow, a sweeping segment). */
  value?: number;
  max: number;
  /** The bar's name ("Import progress"). */
  label: string;
  /** What a screen reader says for the value ("640 of 1,196", or "Starting…"). */
  valueText: string;
};

const finite = (n: number | undefined) => (typeof n === "number" && Number.isFinite(n) ? n : 0);

/** A thin progress bar (board 29's banner). The fill is a logical inline size, so it grows from the start side in RTL too. */
export const ProgressBar = ({ value, max, label, valueText }: Props) => {
  const top = Math.max(0, finite(max));
  const indeterminate = value === undefined;
  const now = Math.min(Math.max(0, finite(value)), top);
  const pct = top > 0 ? Math.round((now / top) * 1000) / 10 : 0;
  return (
    <div role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={top} aria-valuenow={indeterminate ? undefined : now}
      aria-valuetext={valueText} className={s.track}>
      {indeterminate
        ? <div className={`${s.fill} ${s.indeterminate}`} />
        : <div className={s.fill} style={{ inlineSize: `${pct}%` }} />}
    </div>
  );
};
